<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="91.4 NotYet Delivery Status" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="btnExcel()">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined>
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-2">
                                                    <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Ship no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedShip" :items="shipNoList"
                                                            item-value="selectedShip" label="" return-object single-line
                                                            outlined dense @change="shipNoChange"></v-select>
                                                    </v-col>                                                    
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Por no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedPor" :items="porList"
                                                            item-value="selectedPor" return-object single-line outlined
                                                            dense :label="'All'" @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Block : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedBlock" :items="blockList"
                                                            item-value="selectedBlock" return-object single-line
                                                            outlined dense :label="'All'"
                                                            @change="btnRetrieve()"></v-select>
                                                    </v-col>                                                   
                                                </v-row>
                                                <v-row dense class="ma-0">
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 pt-2 subTitle">Duration by : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="reqDiv.select" :items="reqDiv.items"
                                                            item-text="name" item-value="cd" return-object single-line
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="startDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                                                    </v-col>
                                                    <span class="pa-1 pt-2 subTitle"> ~ </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="endDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epms9080" class="listBox" :ref="epms9080Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        :word-wrap-enabled="true"
                                        @cellPrepared="cellPrepared"
                                        >

                                        <DxColumn data-field="rnum" caption="No" width="7%" data-type="string"
                                            :allow-editing="false" alignment="center" />

                                        <DxColumn caption="Ship No" width="15%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="shipNo" caption="Por No" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" cell-template="porNoTemplate"/>
                                        </DxColumn>

                                        <template #porNoTemplate="{ data }">
                                            <div>
                                                <div v-if="data.rowIndex % 2 != 0">
                                                    <v-btn small elevation="0" color="transparent" class="px-0 py-0 my-2 grd-btn" @click.stop="drawingPage($event)">
                                                        {{ data.value.slice(0,8) }}
                                                    </v-btn>-{{ data.value.slice(9,11) }}
                                                </div>
                                                <div v-else>
                                                    {{ data.value }}
                                                </div>                                                                                               
                                            </div>
                                            
                                        </template>     
                                        
                                        <DxColumn data-field="block" caption="Block" width="8%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />
                                                                                                                     
                                        <DxColumn caption="Part No" width="15%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="partNo" caption="Part Specification" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="BOM Qty" width="7%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" header-cell-template="BOM">
                                            <DxColumn data-field="partQty" caption="Part Specification" width="7%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>
                                        <template #BOM>
                                            <div>BOM<br />Qty</div>
                                        </template>
                                        <DxColumn caption="Unit Weight" width="8%" data-type="string"
                                            :allow-editing="false" alignment="right" :visible="true"
                                            header-cell-template="uWgt">
                                            <DxColumn data-field="partUnitWgt" caption="Part Specification" width="8%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>
                                        <template #uWgt>
                                            <div>Unit<br />Weight</div>
                                        </template>
                                        
                                        <DxColumn data-field="nyQty" caption="Not W/H Qty" width="8%"
                                            data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" header-cell-template="notWhQty" />
                                        
                                        <template #notWhQty>
                                            <div>Not W/H<br />Qty</div>
                                        </template>

                                        <DxColumn data-field="stageCd" caption="Stage" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn caption="Material Need Date" width="10%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" header-cell-template="matlNeedDte">
                                            <DxColumn data-field="psdDt" caption="PO Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
                                        
                                        <template #matlNeedDte>
                                            <div>Material<br />Need Date</div>
                                        </template>

                                        <DxColumn caption="Insp Date" width="10%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" >
                                            <DxColumn data-field="distDwgDte" caption="Req.Iss. Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
                                        

                                        <DxColumn caption="Make Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stMakeDte" caption="Make Finish" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
                                        
                                        <DxColumn caption="Pain Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stPaintDte" caption="Pain Finish" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>                                                                        

                                        <DxColumn data-field="quotNo" caption="Quot no" width="15%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="plnDelyDte" caption="Est.Dly.Date" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />                                       

                                        <DxColumn data-field="reqEmp" caption="Requester" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />                                        

                                        <DxPaging :enabled="true" :page-size="14" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
        <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" />
    </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { epms9080List,  epms9080Xls } from '@/api/view/hip/91/epms9080.js'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma } from '@/utils/common.js'

export default {
    name: 'epms9080',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox,
        drawingPagePop
    },
    data() {
        return {
            gridMainList: [],
            epms9080Ref: "epms9080Ref",
            selectedShip: '',
            shipNoList: [],

            selectedPor: 'All',
            porList: [],

            selectedBlock: 'All',
            blockList: [],

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: '',              

            showPop : false,
            dwgPorNo: '',
            
            reqDiv: {
                select: { name: 'Material Need Date', cd: '0' },
                items: [
                    { name: 'Material Need Date', cd: '0' },
                    { name: 'Request Issue', cd: '1' }
                ]
            }
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms9080Ref)
        },
    },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(value) {
            return getNumComma(value)
        },
        drawingPage(e) {
            
            let porNo = e.srcElement.innerText  
            
            this.dwgPorNo = porNo.slice(0, 8)

            console.log(this.dwgPorNo)

            this.showPop = true
        },
        shipNoChange(e) {

            this.porList = [],
            this.blockList = [],

            this.getPorList()
            this.getBlockList()

        },

        btnRetrieve() {
            // if (!this.selectedShip) {
            //     this.vToastify(this.$t('Ship no is not selected.'), 'warn')
            //     return
            // }

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                reqDiv: this.reqDiv.select.cd,                
                stDte: this.stDte,
                fiDte: this.edDte
            }

            await epms9080List(params).then(res => {
                //this.gridMainList = res.list
                let list = []         
                let cnt = 1;       
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.shipNo,                block: e.block, partNo: e.partNo,
                            partQty: e.partQty, partUnitWgt: e.partUnitWgt, nyQty: e.nyQty, stageCd: e.stageCd,
                            psdDt: e.psdDt, distDwgDte: e.distDwgDte, stMakeDte: e.stMakeDte, stPaintDte: e.stPaintDte,
                            quotNo: e.quotNo, plnDelyDte: e.plnDelyDte, reqEmp: e.reqEmp
                        },
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.porNo + '-' + e.porSeq, block: e.block, partNo: e.matlSpec,
                            partQty: e.matlSpec, partUnitWgt: e.matlSpec,   nyQty: e.nyQty, stageCd: e.stageCd,
                            psdDt: e.poDte, distDwgDte: e.reqIssDte, stMakeDte: e.edMakeDte, stPaintDte: e.edPaintDte,
                            quotNo: e.quotNo, plnDelyDte: e.plnDelyDte, reqEmp: e.reqEmp
                        },
                    )
                });
                this.gridMainList = list

            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        async getPorList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_por_no(params).then(res => {
                this.porList.push('All')
                res.list.forEach(e => {
                    this.porList.push(e.porNo)
                });
            })
        },

        async getBlockList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_block(params).then(res => {
                this.blockList.push('All')
                res.list.forEach(e => {
                    this.blockList.push(e.block)
                });
            })
        },

        btnExcel() {
            this.openLoading('Saving Excel!')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                reqDiv: this.reqDiv.select.cd,              
                stDte: this.stDte,
                fiDte: this.edDte
            }

            epms9080Xls(params).finally(() => {
                this.endLoading();
            })

        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'data') {
                if (e.column.caption === 'No' || e.column.caption === 'Block' || e.column.caption === 'Not W/H Qty' || e.column.caption === 'Stage' || e.column.caption === 'Quot no'
                    || e.column.caption === 'Est.Dly.Date' || e.column.caption === 'Requester') {
                    if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')) {
                        e.cellElement.setAttribute('rowspan', 2)
                    } else {
                        e.cellElement.style.display = 'none'
                    }
                    if (e.column.caption === 'Not W/H Qty') {
                        e.cellElement.style.backgroundColor = "#C6D3A0"
                    }                   
                }
                
                if ( ( e.column.name === 'partNo' || e.column.name === 'partQty') && Number(e.rowIndex) % 2 === 0 ) {                    
                    e.cellElement.style.backgroundColor = "#B6D3F0"
                }

                if (e.column.name === 'partUnitWgt'  && Number(e.rowIndex) % 2 === 0) {
                    e.column.alignment = 'right'
                }

                if (e.column.caption === 'Part Specification' && e.columnIndex === 3 ) {
                    if (e.value === e.component.cellValue(e.rowIndex, e.columnIndex + 1)) {
                        e.cellElement.setAttribute('colspan', 3)
                    }
                } else if (e.column.caption === 'Part Specification' && e.columnIndex === 4) {
                    if (e.value === e.component.cellValue(e.rowIndex, e.columnIndex - 1)) {
                        e.cellElement.style.display = 'none'
                    }
                }  else if (e.column.caption === 'Part Specification' && e.columnIndex === 5) {
                    if (e.value === e.component.cellValue(e.rowIndex, e.columnIndex - 1)) {
                        e.cellElement.style.display = 'none'
                    }
                }

            } else {
                if (e.column.caption === 'Part Specification' && e.columnIndex === 1 ) {
                    e.cellElement.setAttribute('colspan', 3)                    
                } else if (e.column.caption === 'Part Specification' && e.columnIndex === 2) {
                     e.cellElement.style.display = 'none'
                 } else if (e.column.caption === 'Part Specification' && e.columnIndex === 3) {
                     e.cellElement.style.display = 'none'
                }
            }
        }
        
    },
    mounted() {
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), 0, 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
        

        this.getShipNoList()
        this.gridMainInstance.option('defaultPaging', false)
    }
}
</script>

<style scoped>

</style>